(function($) {
  $(document).ready(function(){

	$('.think-button').click(function(){
		$('.circle-text').not('.think').removeClass('active');
			$('.think').addClass("active");
	});
	$('.think-button').hover(function(){
		$('.circle-text').not('.think').removeClass('active');
			$('.think').addClass("active");

	});
	$('.solve-button').click(function(){
		$('.circle-text').not('.solve').removeClass('active');
			$('.solve').addClass("active");
	});
	$('.solve-button').hover(function(){
		$('.circle-text').not('.solve').removeClass('active');
			$('.solve').addClass("active");
	});
	$('.plan-button').click(function(){
		$('.circle-text').not('.plan').removeClass('active');
			$('.plan').addClass("active");
	});
		$('.plan-button').hover(function(){
		$('.circle-text').not('.plan').removeClass('active');
			$('.plan').addClass("active");
	});
	$('.change-button').click(function(){
		$('.circle-text').not('.change-cl').removeClass('active');
			$('.change-cl').addClass("active");
	});
	$('.change-button').hover(function(){
		$('.circle-text').not('.change-cl').removeClass('active');
			$('.change-cl').addClass("active");
	});
	$('.improvise-button').click(function(){
		$('.circle-text').not('.improvise').removeClass('active');
			$('.improvise').addClass("active");
	});  
	$('.improvise-button').hover(function(){
		$('.circle-text').not('.improvise').removeClass('active');
			$('.improvise').addClass("active");
	});
	  
	
	 $('map').imageMapResize();
	  
    $('.cycle-slideshow').cycle({
      	});
    //stop video from looping
    $('.noloop .et_pb_section_video_bg').each(function() {
        $(this).find('video').removeAttr('loop');
    });
    var width = $(window).width();
    var height = $(window).height();
	if (width >= 1100) {
		$('.home .banner').append('<div class="scrollarrow" style="text-align: center;"><a href="#courage"><img class="wp-image-26794 size-full" src="https://www.workunscripted.com/wp-content/themes/unscripted/img/chevron.png" alt="" width="43" height="22"></a></div>');
		$(".scrollarrow").delay(2000).fadeIn(1500);
	}
    var menuRight = document.getElementById('cbp-spmenu-s2');
    $('#showRight').click(function() {
				classie.toggle( this, 'active' );
				$('body').toggleClass('fixedPosition');
				classie.toggle( menuRight, 'cbp-spmenu-open' );
		});
	if (width >= 701) {
		 $('.workshops').each(function(){
		   // Cache the highest
		   var highestBox = 0;
		   // Select and loop the elements you want to equalise
		   $('.et_pb_slide', this).each(function(){
			 // If this box is higher than the cached highest then store it
			 if($(this).height() > highestBox) {
			   highestBox = $(this).height();
			 }
		   });
		   // Set the height of all those children to whichever was highest
		   $('.et_pb_slide',this).height(highestBox);
		 });
	}
  if (width >= 701) {
  		 $('.company-quote').each(function(){
  		   // Cache the highest
  		   var highestBox = 0;
  		   // Select and loop the elements you want to equalise
  		   $('.et_pb_text ', this).each(function(){
  			 // If this box is higher than the cached highest then store it
  			 if($(this).height() > highestBox) {
  			   highestBox = $(this).height();
  			 }
  		   });
  		   // Set the height of all those children to whichever was highest
  		   $('.et_pb_text ',this).height(highestBox);
  		 });
	}
	if (width >= 701) {
  		 $('.unscripted-callout').each(function(){
  		   // Cache the highest
  		   var highestBox = 0;
  		   // Select and loop the elements you want to equalise
  		   $('.et_pb_column_1_2 ', this).each(function(){
  			 // If this box is higher than the cached highest then store it
  			 if($(this).height() > highestBox) {
  			   highestBox = $(this).height();
  			 }
  		   });
  		   // Set the height of all those children to whichever was highest
  		   $('.et_pb_column_1_2 ',this).height(highestBox);
  		 });
	}
	if (width >= 701) {
  		 $('.callout').each(function(){
  		   // Cache the highest
  		   var highestBox = 0;
  		   // Select and loop the elements you want to equalise
  		   $('.et_pb_column_1_4 ', this).each(function(){
  			 // If this box is higher than the cached highest then store it
  			 if($(this).height() > highestBox) {
  			   highestBox = $(this).height();
  			 }
  		   });
  		   // Set the height of all those children to whichever was highest
  		   $('.et_pb_column_1_4 ',this).height(highestBox);
  		 });
	}

	});
	
	
	
  var tempEmail = 'EMAIL*';
  	$("#mce-EMAIL").focus(function() {
  	if (tempEmail == this.value)
  		// ------^-- empty the field only if the field value is initial
  		this.value = '';
  		// emptying field value
  	}).blur(function() {
  	if (this.value.trim() == '')
  		// -----^-- condition field value is empty
  		this.value = tempEmail;
  		// if empty then updating with initial value
  	}).val(tempEmail);
  	//----^-- setting initial value
  	var tempFname = 'FIRST NAME*';
  	$("#mce-FNAME").focus(function() {
  	if (tempFname == this.value)
  		// ------^-- empty the field only if the field value is initial
  		this.value = '';
  		// emptying field value
  	}).blur(function() {
  	if (this.value.trim() == '')
  		// -----^-- condition field value is empty
  		this.value = tempFname;
  		// if empty then updating with initial value
  	}).val(tempFname);
  	//----^-- setting initial value
	
	var tempLname = 'LAST NAME*';
  	$("#mce-LNAME").focus(function() {
  	if (tempLname == this.value)
  		// ------^-- empty the field only if the field value is initial
  		this.value = '';
  		// emptying field value
  	}).blur(function() {
  	if (this.value.trim() == '')
  		// -----^-- condition field value is empty
  		this.value = tempLname;
  		// if empty then updating with initial value
  	}).val(tempLname);
  	//----^-- setting initial value
	
	
	$('.videobutton').click(function(){
			if($('.et_pb_section_video_bg video').length > 0){
				$('.et_pb_section_video_bg video')[0].player.pause();
			
			}
			var theModal = $('#myModal');
			videoSRC = 'https://www.youtube.com/embed/rBgoZVrr4rA';
			videoSRCauto = videoSRC + "?rel=0&controls=1&showinfo=0&html5=1&autoplay=1";
			
			$('#myModal iframe').attr('src', videoSRCauto);

			$(theModal).css('display', 'block'); 
		});
 	$('.videobutton-gmid img').click(function(){

			var theModal = $('#myModal');
			videoSRC = 'https://www.youtube.com/embed/6Xiw-OqvLsk';
			videoSRCauto = videoSRC + "?rel=0&controls=1&showinfo=0&html5=1&autoplay=1";
			
			$('#myModal iframe').attr('src', videoSRCauto);

			$(theModal).css('display', 'block'); 
		});
 	$('div.videobutton-gmid').click(function(){
			var theModal = $('#myModal');
			videoSRC = 'https://www.youtube.com/embed/6Xiw-OqvLsk';
			videoSRCauto = videoSRC + "?rel=0&controls=1&showinfo=0&html5=1&autoplay=1";
			
			$('#myModal iframe').attr('src', videoSRCauto);

			$(theModal).css('display', 'block'); 
		});
		$('.videobutton-speaker').click(function(){

			var theModal = $('#myModal');
			videoSRC = 'https://www.youtube.com/embed/clr5SzwpgLc';
			videoSRCauto = videoSRC + "?rel=0&controls=1&showinfo=0&html5=1&autoplay=1";
			
			$('#myModal iframe').attr('src', videoSRCauto);

			$(theModal).css('display', 'block'); 
		});
	// When the user clicks anywhere outside of the modal, close it
	$(window).click(function(e) {
		
		if (e.target.id == 'myModal') {
			$('#myModal').hide();
			$('#myModal iframe').attr('src', '');
			if($('.et_pb_section_video_bg video').length > 0){
				$('.et_pb_section_video_bg video')[0].player.play();
			}
		}
	});
	
	
	
})(jQuery);
jQuery(function($){
  $('.et_pb_toggle_title').click(function(){
    var $toggle = $(this).closest('.et_pb_toggle');
    if (!$toggle.hasClass('et_pb_accordion_toggling')) {
      var $accordion = $toggle.closest('.et_pb_accordion');
      if ($toggle.hasClass('et_pb_toggle_open')) {
        $accordion.addClass('et_pb_accordion_toggling');
        $toggle.find('.et_pb_toggle_content').slideToggle(700, function() {
          $toggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close');
        });
      }
      setTimeout(function(){
        $accordion.removeClass('et_pb_accordion_toggling');
      }, 750);
    }
  });
  

	
	
});
(function($) {
  $(document).ready(function(){
	var $burger = $('.burger');
	var $bars = $('.burger-svg__bars');
	var $bar = $('.burger-svg__bar');
	var $bar1 = $('.burger-svg__bar-1');
	var $bar2 = $('.burger-svg__bar-2');
	var $bar3 = $('.burger-svg__bar-3');
	var isChangingState = false;
	var isOpen = false;
	var burgerTL = new TimelineMax();
	function burgerOver() {
		if(!isChangingState) {
			burgerTL.clear();
			if(!isOpen) {
				burgerTL.to($bar1, 0.5, { y: -2, ease: Elastic.easeOut })
						.to($bar2, 0.5, { scaleX: 0.6, ease: Elastic.easeOut, transformOrigin: "50% 50%" }, "-=0.5")
						.to($bar3, 0.5, { y: 2, ease: Elastic.easeOut }, "-=0.5");
			}
			else {
				burgerTL.to($bar1, 0.5, { scaleX: 1.2, ease: Elastic.easeOut })
						.to($bar3, 0.5, { scaleX: 1.2, ease: Elastic.easeOut }, "-=0.5");
			}
		}
	}
	function burgerOut() {
		if(!isChangingState) {
			burgerTL.clear();
			if(!isOpen) {
				burgerTL.to($bar1, 0.5, { y: 0, ease: Elastic.easeOut })
						.to($bar2, 0.5, { scaleX: 1, ease: Elastic.easeOut, transformOrigin: "50% 50%" }, "-=0.5")
						.to($bar3, 0.5, { y: 0, ease: Elastic.easeOut }, "-=0.5");
			}
			else {
				burgerTL.to($bar1, 0.5, { scaleX: 1, ease: Elastic.easeOut })
						.to($bar3, 0.5, { scaleX: 1, ease: Elastic.easeOut }, "-=0.5");
			}
		}
	}
	function showCloseBurger() {
		burgerTL.clear();
		burgerTL.to($bar1, 0.3, { y: 6, ease: Power4.easeIn })
				.to($bar2, 0.3, { scaleX: 1, ease: Power4.easeIn }, "-=0.3")
				.to($bar3, 0.3, { y: -6, ease: Power4.easeIn }, "-=0.3")
				.to($bar1, 0.5, { rotation: 45, ease: Elastic.easeOut, transformOrigin: "50% 50%" })
				.set($bar2, { opacity: 0, immediateRender: false }, "-=0.5")
				.to($bar3, 0.5, { rotation: -45, ease: Elastic.easeOut, transformOrigin: "50% 50%", onComplete: function() { isChangingState = false; isOpen = true; } }, "-=0.5");
	}
	function showOpenBurger() {
		burgerTL.clear();
		burgerTL.to($bar1, 0.3, { scaleX: 0, ease: Back.easeIn })
				.to($bar3, 0.3, { scaleX: 0, ease: Back.easeIn }, "-=0.3")
				.set($bar1, { rotation: 0, y: 0 })
				.set($bar2, { scaleX: 0, opacity: 1 })
				.set($bar3, { rotation: 0, y: 0 })
				.to($bar2, 0.5, { scaleX: 1, ease: Elastic.easeOut })
				.to($bar1, 0.5, { scaleX: 1, ease: Elastic.easeOut }, "-=0.4")
				.to($bar3, 0.5, { scaleX: 1, ease: Elastic.easeOut, onComplete: function() { isChangingState = false; isOpen = false; } }, "-=0.5");
	}
	$burger.on('click', function(e) {
		if(!isChangingState) {
			isChangingState = true;
			if(!isOpen) {
				showCloseBurger();
			}
			else {
				showOpenBurger();
			}
		}
	});
	$burger.hover( burgerOver, burgerOut );
	});
})(jQuery);


// text fade in and fade out on the speaking page .rotating-text
(function($) {
	$(document).ready(function(){
		// Configure timing
		const fadeInDuration = 500;  // 1 second fade in
		const displayDuration = 2000; // 3 seconds display
		const fadeOutDuration = 500; // 1 second fade out
		
		const $phrases = $('.rotating-text h2');
		let currentIndex = 0;
		
		// Hide all phrases initially
		$phrases.hide();
		
		// Function to rotate phrases
		function rotatePhrases() {
			// Fade out current phrase
			$phrases.eq(currentIndex).fadeOut(fadeOutDuration, function() {
				// Update index to next phrase (with loop)
				currentIndex = (currentIndex + 1) % $phrases.length;
				
				// Fade in next phrase
				$phrases.eq(currentIndex).fadeIn(fadeInDuration, function() {
					// Wait for display duration, then start next rotation
					setTimeout(rotatePhrases, displayDuration);
				});
			});
		}
		
		// Start with the first phrase
		$phrases.eq(0).fadeIn(fadeInDuration, function() {
			// After first phrase has faded in, wait for display duration then start rotation
			setTimeout(rotatePhrases, displayDuration);
		});
	});
})(jQuery);